import { Link } from 'react-router-dom';
import { Instagram, Facebook, Twitter, Music2 } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_sip-schedule-admin/artifacts/vd09zrou_Logo%20-%20Final.png";

const socialLinks = [
  { icon: Instagram, href: 'https://instagram.com', label: 'Instagram', color: 'hover:bg-[#E1306C]' },
  { icon: Facebook, href: 'https://facebook.com', label: 'Facebook', color: 'hover:bg-[#1877F2]' },
  { icon: Twitter, href: 'https://twitter.com', label: 'Twitter/X', color: 'hover:bg-black' },
  { icon: Music2, href: 'https://tiktok.com', label: 'TikTok', color: 'hover:bg-[#000000]' },
];

const footerLinks = [
  { to: '/schedule', label: 'Find Us' },
  { to: '/menu', label: 'Menu' },
  { to: '/seasonal', label: 'Seasonal' },
  { to: '/events', label: 'Private Events' },
  { to: '/rewards', label: 'Rewards' },
  { to: '/community', label: 'Community' },
  { to: '/about', label: 'About Us' },
  { to: '/gallery', label: 'Gallery' },
];

export const Footer = () => {
  return (
    <footer className="bg-gradient-to-br from-sip-purple to-sip-purple/90 text-white" data-testid="footer">
      {/* Wave decoration */}
      <div className="h-6 bg-sip-cyan" style={{
        clipPath: 'polygon(0 100%, 100% 100%, 100% 0, 75% 60%, 50% 20%, 25% 60%, 0 0)'
      }} />
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Brand */}
          <div>
            <img 
              src={LOGO_URL} 
              alt="Sip Fantasia" 
              className="h-20 w-auto mb-4 bg-white rounded-xl p-2"
            />
            <p className="text-white/80 mb-6">
              Serving bold flavors and big smiles - One fun sip at a time.
            </p>
            
            {/* Social Links */}
            <div className="flex gap-3" data-testid="social-links">
              {socialLinks.map((social) => {
                const Icon = social.icon;
                return (
                  <a
                    key={social.label}
                    href={social.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`p-3 bg-white/10 rounded-full transition-all ${social.color} hover:text-white hover:scale-110`}
                    data-testid={`social-${social.label.toLowerCase()}`}
                    aria-label={social.label}
                  >
                    <Icon size={20} />
                  </a>
                );
              })}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-script text-2xl text-sip-yellow mb-4">
              Quick Links
            </h4>
            <ul className="space-y-2">
              {footerLinks.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-white/80 hover:text-sip-yellow transition-colors"
                    data-testid={`footer-link-${link.label.toLowerCase().replace(' ', '-')}`}
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-script text-2xl text-sip-yellow mb-4">
              Get In Touch
            </h4>
            <div className="text-white/80 space-y-2">
              <p>Book us for your next event!</p>
              <Link 
                to="/events" 
                className="inline-block mt-4 px-6 py-2 bg-sip-pink text-white font-semibold rounded-full hover:bg-sip-pink/80 transition-colors"
                data-testid="footer-cta-events"
              >
                Book Now
              </Link>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-white/20 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-white/60">
            &copy; {new Date().getFullYear()} Sip Fantasia. All rights reserved.
          </p>
          <Link 
            to="/login" 
            className="text-sm text-white/50 hover:text-sip-yellow transition-colors"
            data-testid="admin-link"
          >
            Admin Login
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
